import { createContext } from 'react';
import { IOpportunityFilter } from './models/model';

const filterValue: IOpportunityFilter = {
  selectedPositions: [],
  selectedTechnologies: [],
  page: 0,
  selectedChallenges: [],
};
export const OpportunityFilterContext = createContext(filterValue);
